import type { AppEnvironment } from './environment.type';

export const environment: AppEnvironment = {
  name: 'quality',
  production: false,
  apiUrl: 'https://api-ob.manysphere.info/api/v1',
};
